<template>
  <div id="cookie" class="container">
    <SfBreadcrumbs
        :breadcrumbs="breadcrumbs"
        class="breadcrumbs"
    />
    <div class="content">
      <div v-if="locale==='fr'">
        <h1>Politique de protection des données personnelles</h1>
        <h2> IDENTITES ET COORDONNEES DU RESPONSABLE DU TRAITEMENT</h2>
        <p>Les objets de marque Air France et autres articles proposés sur le site shopping.airfrance.com sont
          distribués
          par la société <b>Socatec</b> (ci-après dénommée <b>Socatec</b>) pour le compte de la société Air France
          (immatriculée au RCS
          de Bobigny sous le numéro 420 495 178).</p>
        <p>Les données à caractère personnel permettant d’identifier une personne sont traitées par la société
          <b>Socatec</b> et
          sa filiale onebird (ci-après dénommée onebird) en qualité de sous-traitants direct et indirect de la société
          Air
          France.</p>
        <p>Les sociétés <b>Socatec</b> (immatriculée au RCS de Paris sous le numéro 319 981 783) et onebird
          (immatriculée
          au RCS
          de Paris sous le numéro 911 049 724) ont leur siège social au 131 boulevard Pereire 75017 Paris, France.</p>
        <p>L’utilisateur est informé que la société <b>Supplyweb</b> (immatriculée au RCS de Caen sous le numéro
          532948585
          et
          ci-après dénommée <b>Supplyweb</b>) assure le traitement logistique des commandes en qualité de sous-traitant
          de
          <b>Socatec</b> et de sa filiale. A ce titre, la société <b>Supplyweb</b> traite également les données à
          caractère personnel de
          l’utilisateur du site.</p>
        <p><b>Supplyweb</b> a son siège social 4 rue Newton 14120 Mondéville, France</p>
        <p>Ces sociétés sont soumises au Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016,
          relatif à la protection des personnes physiques à l'égard du traitement des données à caractère personnel et à
          la libre circulation de ces données.</p>
        <p>Le délégué à la protection des données peut être contacté à l’adresse suivante : <a
            href="mailto:dpo@socatec.aero">dpo@socatec.aero</a></p>

        <h2>COLLECTE DES DONNEES</h2>
        <p>L’utilisateur est informé que des cookies enregistrent certaines informations qui sont stockées dans la
          mémoire
          de son disque dur. Ces informations servent, notamment, à générer des statistiques d'audience du site et à
          proposer à l'utilisateur des produits selon les articles que l'utilisateur a déjà sélectionnés lors de ses
          précédentes visites. Un message d'alerte demande à l'utilisateur, au préalable, s'il souhaite accepter les
          cookies, ce qu'il peut bien entendu refuser. Ces cookies ne contiennent pas d'informations confidentielles
          concernant l'utilisateur.</p>
        <p>Pour plus d’information sur les données collectées automatiquement après y avoir consenti, l’utilisateur est
          invité à se reporter à la page "gestion des cookies".</p>
        <p>Les données communiquées par l’utilisateur sont collectées dans un but légitime et proportionné. Elles sont
          indispensables au traitement, à l'acheminement et à la facturation de la commande ainsi qu'à la qualité de
          service due à l’utilisateur pendant et après le traitement de sa commande. Ces données personnelles font
          l'objet
          d'un traitement informatique pour les raisons indiquées ci-dessus. En s'inscrivant sur le site, l'utilisateur
          s'engage à communiquer à <b>Socatec</b> des informations sincères et valables le concernant.</p>
        <p>Les données collectées, traitées et archivées sont :</p>

        <ul>
          <li>• Nom</li>
          <li>• Prénom</li>
          <li>• Raison sociale</li>
          <li>• Siret</li>
          <li>• N° de TVA</li>
          <li>• Adresse de facturation</li>
          <li>• Adresse de livraison</li>
          <li>• Numéro de téléphone</li>
          <li>• Adresse email</li>
          <li>• Données relatives aux moyens de paiement (immédiatement effacées)</li>
          <li>• Historique des achats</li>
          <li>• Adresse IP</li>
          <li>• Login</li>
          <li>• Mot de passe sous forme cryptée</li>
          <li>• Logs de connexion</li>
        </ul>

        <p>Ces données sont collectées sur la base du consentement de l’utilisateur.</p>
        <p>La base légale est l'exécution contractuelle (gestion de la commande, paiement et livraison) et l’envoi de
          sollicitations commerciales si l’utilisateur l'a accepté.</p>
        <p>Les données sont collectées, traitées et stockées dans le système de gestion de contenu de commerce
          électronique propriétaire Air France Shopping hébergé en France et opéré par <b>Socatec</b>.</p>
        <p>Les destinataires des données sont les services clients, logistiques (entrepôt et prestataires de transport)
          et
          comptables de <b>Socatec</b> et / ou de ses sous-traitants. Les personnes ayant accès aux données sont des
          salariés de
          <b>Socatec</b> et / ou de ses sous-traitants et sont soumis à une obligation de confidentialité et
          sensibilisés
          à
          l'enjeu de protection des données nominatives.</p>
        <p>Pour le besoin de l'acheminement des colis, <b>Socatec</b> et <b>Supplyweb</b> font appel à des prestataires
          externes : La
          Poste, Chronopost et DHL. Ces sous-traitants sont destinataires de l'identité, de l'adresse et du numéro de
          téléphone de l’utilisateur. Ils sont tenus aux mêmes règles de traitement des données nominatives.</p>

        <p>La politique et les moyens mis en oeuvre par ces prestataires sont accessibles par les liens suivants :</p>
        <a class="sf-link color-tertiary" href="https://www.laposte.fr/politique-de-protection-des-donnees"
           target="_blank">https://www.laposte.fr/politique-de-protection-des-donnees</a><br/>
        <a class="sf-link color-tertiary" href="https://www.chronopost.fr/fr/politique-informatique-et-libertes"
           target="_blank">https://www.chronopost.fr/fr/politique-informatique-et-libertes</a><br/>
        <a class="sf-link color-tertiary"
           href="https://www.dhl.com/fr-fr/home/bas-de-page/avis-de-confidentialite.html#parsysPath_text_media"
           target="_blank">https://www.dhl.com/fr-fr/home/bas-de-page/avis-de-confidentialite.html#parsysPath_text_media</a><br/>
        <p>Les accords de sous-traitance entre <b>Socatec</b> et ses prestataires précisent les obligations de chaque
          partie en
          matière de données personnelles et intègrent les exigences de l’article 28 de la réglementation mentionnée
          ci-dessus.</p>

        <h2>DUREE DE CONSERVATION DES DONNEES</h2>
        <p>Les données nécessaires à la gestion des commandes et de la facturation sont conservées pendant toute le
          durée
          de la relation commerciale. Elles sont ensuite archivées 10 ans après la collecte au titre des obligations
          fiscales et comptables (Article L. 123-22 alinéa 2 du Code de commerce).</p>
        <p>Les données nécessaires à la réalisation des actions de fidélisation et de prospection sont conservées
          pendant
          toute la durée de la relation commerciale et jusqu’à 3 ans à compter du dernier achat.</p>
        <p>Les données relatives aux moyens de paiement ne sont pas conservées par <b>Socatec</b>. Elles sont transmises
          à
          l'établissement bancaire sous forme cryptée et immédiatement effacées après l'achat.</p>
        <p>Le sous-traitant en charge du traitement des paiements en ligne est la société Adyen dont le siège social est
          situé Simon Carmiggeltstraat 6-50 1011 DJ, Amsterdam, Pays-Bas</p>
        <p>Pour plus d’informations : <a class="sf-link color-tertiary"
                                         href="https://www.adyen.com/fr_FR/politiques-et-mentions-legales/privacy-policy"
                                         target="_blank">https://www.adyen.com/fr_FR/politiques-et-mentions-legales/privacy-policy</a>
        </p>
        <p>Les données relatives à la liste d'opposition à la réception de prospection sont conservées 3 ans.</p>
        <p>Après l’étape de 3 ans d’utilisation courante des données (base active), les données font l’objet d’un
          archivage intermédiaire pour répondre aux besoins contentieux et aux exigences légales de conservation des
          données mentionnées ci-dessus.</p>
        <p>Elles font ensuite l’objet d’un processus d’anonymisation qui rend l’identification des personnes impossible
          pour permette ensuite une seule exploitation statistique sans porter atteinte à la vie privée.</p>
        <p>Si l’utilisateur l'a accepté au moment de l'inscription sur le site, <b>Socatec</b> ou sa filiale lui fera
          parvenir
          ponctuellement des offres spéciales et des informations sur ses nouveautés.</p>
        <p>En aucun cas, les données de l’utilisateur ne seront transmises, sous quelque forme que ce soit, à titre
          gratuit ou onéreux, à une entité tierce quel qu'en soit le but, à l'exception des prestataires techniques,
          logistiques et de transport cités ci-dessus.</p>
        <p>Si l’utilisateur souhaite revenir sur son choix, il peut contacter <b>Socatec</b> pour faire supprimer son
          contact de
          la liste de diffusion. <b>Socatec</b> s'engage à supprimer le contact sous 72 heures.</p>

        <h2>DROITS DES UTILISATEURS</h2>
        <p>L'utilisateur a un droit permanent d'accès et de rectification pour toutes les données le concernant,
          conformément aux textes européens et aux lois nationales en vigueur (règlement (UE) 2016/679, dit Règlement
          Général sur la Protection des Données). A tout moment, l’utilisateur peut faire une demande auprès de
          <b>Socatec</b>
          afin de connaitre les informations le concernant dont il dispose.</p>
        <p>Il peut, à tout moment et sur demande, modifier ces données.</p>
        <p><b>Socatec</b> s'engage à répondre à l'utilisateur sous 72 heures.</p>
        <p>Le responsable du traitement des données est le représentant légal de <b>Socatec</b>.</p>
        <p>Adresse email : <a class="sf-link color-tertiary" href="mailto:dpo@socatec.aero">dpo@socatec.aero</a></p>
        <p>Pour exercer ses droits ou pour toute question relative à ses données et à leur traitement, l’utilisateur
          peut
          contacter le délégué à la protection des données de <b>Socatec</b> à l'adresse <a
              class="sf-link color-tertiary"
              href="mailto:dpo@socatec.aero">dpo@socatec.aero</a>
          ou par lettre envoyée à
          <b>Socatec</b> 131, boulevard Pereire 75017 Paris.</p>
        <p><b>Socatec</b> s’engage à informer la CNIL sous 72 heures en cas de perte ou de vol des données.</p>
        <p>Si l’utilisateur estime que ses droits ne sont pas respectés, il lui est possible de solliciter
          l’intervention
          de la CNIL : <a class="sf-link color-tertiary" href="http://cnil.fr" target="_blank">http://cnil.fr</a>.</p>

        <h2>ACTIONS ENTREPRISES PAR <b>Socatec</b></h2>
        <p>Sensibilisation du personnel de <b>Socatec</b> aux enjeux de la réglementation RGPD</p>
        <p>Engagement contractuel des sous-traitants (RGPD et sécurité informatique)</p>
        <p>Collecte des seules données indispensables au traitement, suivi des commandes et actions commerciales pour
          les
          seules personnes y ayant clairement consenti, à l’exclusion de toutes données sensibles</p>
        <p>Etablissement d’une politique de collecte, de gestion et de confidentialité des données</p>
        <p>Mise en place d’une procédure de purge automatique des données personnelles au terme de la durée de
          conservation automatique ou d’archivage pour les données qui doivent légalement être conservées plus
          longtemps.</p>
        <p>Tenue du registre des traitements (article 30), du registre des activités de sous-traitance (article 30.2) et
          du registre des violations de données à caractère personnel (article 33).</p>

      </div>
      <div v-else>
        <h1>PRIVACY POLICY</h1>

        <h2>DATA CONTROLLER INFORMATION AND CONTACT DETAILS</h2>

        <p>Air France branded products and other articles available on the shopping.airfrance.com website are
          distributed by <b>Socatec</b> on behalf of Air France S.A. (registered in Bobigny under company number RCS 420
          495
          178).</p>

        <p>In their role as direct and indirect subcontractors for Air France, <b>Socatec</b> and its subsidiary <b>onebird</b>
          process
          personal data, i.e. data relating to a person which allows that person to be identified. </p>

        <p>The registered offices of <b>Socatec</b> SAS (registered in Paris under company number RCS 319 981 783) and
          <b>onebird
            SAS</b> (registered in Paris under company number RCS 911 049 724) are located at 131 boulevard Pereire,
          75017
          Paris, France.</p>

        <p>We also inform users of this website that <b>Supplyweb SAS</b> (registered in Caen under company number RCS
          532 948
          585 and hereafter referred to as <b>Supplyweb</b>) is responsible for handling order logistics, as a
          subcontractor
          for <b>Socatec</b> and <b>onebird</b>. <b>Supplyweb</b> therefore also processes personal data relating to
          users of this
          website.</p>

        <p>Supplyweb’s registered office is located at 4 rue Newton, 14120 Mondéville, France</p>

        <p>These companies are all bound by Regulation (EU) 2016/679 of the European Parliament and of the Council of 27
          April 2016 on the protection of natural persons with regard to the processing of personal data and on the free
          movement of such data.</p>

        <p>You can contact the Data Protection Officer for this website by email at the following address: <a
            class="sf-link color-tertiary" href="mailto:dpo@socatec.aero">dpo@socatec.aero</a></p>


        <h2> DATA COLLECTION</h2>

        <p>This website uses cookies to store certain information, which is then saved on your device. This information
          is used to compile site usage statistics and to suggest products based on the articles you selected during
          previous visits to the website. When you first visit the site, a cookie banner will ask if you accept cookies,
          which you can of course decline. These cookies do not contain any confidential information about users.</p>
        <p>For more information on the data that cookies collect automatically once you have accepted them, we invite
          you to consult our cookie consent page.</p>

        <p>Data provided by users is collected for legitimate purposes in a proportionate manner to the aim pursued.
          This data is necessary to process, dispatch and invoice orders, as well as to provide users with quality
          customer service during and after order completion. For the above reasons, this personal data is processed
          electronically. When a user creates an account on this website, he or she agrees to provide <b>Socatec</b>
          with
          genuine, accurate information.</p>

        <p>The following data is collected, processed and stored:</p>
        <ul>
          <li> Last name</li>
          <li> First name</li>
          <li> Company name</li>
          <li> Company registration number</li>
          <li> VAT number</li>
          <li> Billing address</li>
          <li> Delivery address</li>
          <li> Telephone number</li>
          <li> Email address</li>
          <li> Payment information (which is then immediately deleted)</li>
          <li> Purchase history</li>
          <li> IP address</li>
          <li> Login</li>
          <li> Encrypted password</li>
          <li> Connection logs</li>
        </ul>
        <p>This data is collected based on the user’s consent.</p>

        <p>The legal basis for processing data is the performance of a contract (order management, payment and
          delivery). If the user has given their consent, their data may also be used to send offers and
          advertising.</p>

        <p>Data is collected, processed and stored in the Air France Shopping proprietary e-commerce content management
          system, which is operated by <b>Socatec</b> and hosted in France.</p>

        <p>The recipients of this data are the customer service, logistics (warehousing and transport) and accounts
          departments within <b>Socatec</b> and/or its subcontractors. The persons authorised to access data are
          employees of <b>Socatec</b> and/or its subcontractors. They are bound by an obligation of confidentiality and
          are aware of the
          importance of protecting personal data.</p>

        <p><b>Socatec</b> and <b>Supplyweb</b> use the following service providers to transport and deliver parcels: La
          Poste,
          Chronopost and DHL. The user’s name, address and telephone number are transferred to these subcontractors, who
          are bound by the same rules regarding personal data processing.</p>

        <p>You can consult the data protection policies and processes implemented by these service providers below:</p>

        <a class="sf-link color-tertiary" href="https://www.laposte.fr/politique-de-protection-des-donnees"
           target="_blank">https://www.laposte.fr/politique-de-protection-des-donnees</a><br/>

        <a class="sf-link color-tertiary" href="https://www.chronopost.fr/en/data-protection-policy" target="_blank">https://www.chronopost.fr/en/data-protection-policy</a><br/>

        <a class="sf-link color-tertiary" href="https://www.dhl.com/fr-en/home/footer/privacy-notice.html"
           target="_blank">https://www.dhl.com/fr-en/home/footer/privacy-notice.html</a>

        <p>The subcontracting agreements between <b>Socatec</b> and its service providers specify each party’s
          obligations
          regarding personal data and include the requirements of Article 28 of the aforementioned Regulation.</p>


        <h2>DATA STORAGE</h2>

        <p>Data that is necessary to manage orders and issue invoices shall be retained for the whole duration of the
          relationship with the customer. It will then be archived for 10 years as of the date it was collected, in
          accordance with accounting and tax obligations in France (Article L.123-22 alinéa 2 of the French Commercial
          Code).</p>

        <p>Data that is necessary to carry out customer loyalty campaigns or direct marketing shall be retained for the
          whole duration of the relationship with the customer and for 3 years after their last purchase.</p>

        <p><b>Socatec</b> does not store customers’ credit card details or other payment information. Once this
          information has
          been encrypted and transferred to the bank to complete the purchase, it is immediately deleted.</p>
        <p>The company responsible for processing online payments is Ayden N.V, whose registered office is located at
          Simon Carmiggeltstraat 6-50, 1011 DJ, Amsterdam, Holland.</p>

        <p>For more information: <a class="sf-link color-tertiary"
                                    href="https://www.adyen.com/fr_FR/politiques-et-mentions-legales/privacy-policy"
                                    target="_blank">https://www.adyen.com/fr_FR/politiques-et-mentions-legales/privacy-policy</a>
        </p>

        <p>Data relating to the list of customers that have refused to receive direct marketing will be retained for 3
          years.</p>

        <p>After a 3-year period of standard use (active database), data will be archived to help settle any future
          disputes and to comply with the aforementioned statutory data retention requirements.</p>
        <p>Data will then be rendered anonymous in such a manner that the persons concerned can no longer be identified,
          so that it may be used for statistical purposes without infringing on privacy.</p>

        <p><b>Socatec</b> or its subsidiary will occasionally send special offers and information on new products to
          users that
          gave their consent for such content when they created their account on the website.</p>

        <p>User data shall not be transferred to any third parties in any form, for any purpose or under any
          circumstances, either free of charge or for a fee, with the exception of the technical, logistics and
          transport service providers mentioned above.</p>

        <p> If a user wishes to withdraw his or her consent, he or she may contact <b>Socatec</b> to have his or her
          contact
          details deleted from the mailing list. <b>Socatec</b> pledges to delete the user’s contact details within 72
          hours.


        <h2>RIGHTS OF USERS:</h2>

        <p>Each user has the ongoing right to access and rectify all personal data that has been collected concerning
          him or her, in accordance with existing European regulations and national laws (Regulation (EU) 2016/679,
          known as the General Data Protection Regulation). The user may contact <b>Socatec</b> at any time to request
          access
          to the personal data that the company has collected concerning him or her.</p>
        <p>He or she may also request the modification of this data at any time.</p>
        <p><b>Socatec</b> pledges to reply to the user within 72 hours.</p>

        <p>The data controller for this website is the legal representative of<b>Socatec</b>.</p>
        <p>Email: <a class="sf-link color-tertiary" href="mailto:dpo@socatec.aero">dpo@socatec.aero</a></p>

        <p>To exercise your rights, or to obtain more information about your personal data and how it is processed, you
          may contact the Data Protection Officer at<b>Socatec</b> by email: <a class="sf-link color-tertiary"
                                                                                href="mailto:dpo@socatec.aero">dpo@socatec.aero</a>
          or by post at the following address:<b>Socatec</b>, 131, boulevard Pereire 75017 Paris.</p>

        <p>Socatec pledges to inform the CNIL (French data protection authority) within 72 hours should any data be lost
          or stolen.</p>

        <p>If a user considers that his or her rights have not been respected, he or she may request the intervention of
          the CNIL: <a class="sf-link color-tertiary" href="https://www.cnil.fr/en/home" target="_blank">https://www.cnil.fr/en/home</a>
          .</p>

        <h2>ACTIONS TAKEN BY SOCATEC:</h2>

        <p><b>Socatec’s staff</b> have been made aware of the GDPR Regulation and related issues.</p>

        <p>Subcontractors have made contractual commitments (GDPR and information security).</p>

        <p>Data collection is limited to the information required to process and manage orders, and to send marketing
          campaigns to users who have clearly consented to receiving them. This excludes the collection of any sensitive
          data.</p>

        <p><b>Socatec</b> has enacted a data collection, management and confidentiality policy.</p>

        <p>An automatic process has been implemented to remove personal data once it has reached the end of its
          designated retention period, and to archive data that must be retained for a longer period due to legal
          requirements.</p>

        <p><b>Socatec</b> maintains a record of processing activities (Article 30), a record of processing activities
          carried
          out by subcontractors (Article 30.2) and a record of any personal data breaches (Article 33).</p>
      </div>
    </div>


  </div>
</template>

<script>
import {SfBreadcrumbs} from "@storefront-ui/vue"
import Api from '@/api/Api';


export default {
  name: "Cookies",
  components: {
    SfBreadcrumbs
  },
  data() {
    return {
      breadcrumbs: null,
      loading: false,
      error: false,
      content: null,
      locale: this.$i18n.locale,
    }
  },
  created() {
    this.setBreadcrumbs();
    this.getContent();
  },
  methods: {
    setBreadcrumbs() {

      this.breadcrumbs = [{
        text: this.$i18n.t('Home'),
        link: '/'
      }, {
        text: this.$i18n.t('rgpd.pageTitle'),
      }];

    },
    getContent() {
      this.loading = true;
      Api.marketing.getFaq()
          .then((data) => {
            this.content = data;
          })
          .catch((err) => {
            this.error = true;
          })
          .finally(this.loading = false);
    }
  },
}
</script>

<style lang="scss" scoped>


::v-deep {
  .sf-button {
    justify-content: space-between !important;
  }
}

.error-msg {
  text-align: center;
}
</style>